import { Fragment } from 'react';
import { Transition, Popover } from '@headlessui/react';
import { faPhone, faCommentQuestion } from '@fortawesome/pro-solid-svg-icons';
import { faUserHeadset } from '@fortawesome/pro-light-svg-icons';

import HelpLink from '../HelpLink';
import DesktopNavIconButton from './DesktopNavIconButton';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

export default function DesktopSupportPopover() {
  const { buildUrl } = useUrlGenerator();

  return (
    <Popover className="relative z-[260]">
      <Popover.Button as={DesktopNavIconButton} icon={faUserHeadset} title="Support" aria-label="Support" />
      {/*
        as={Fragment} is load-bearing, not tidiness, and the offset below depends on it.

        Without it Transition renders a real <div> and puts the transition classes on
        that. `scale-95` makes that wrapper a containing block for absolutely positioned
        descendants, so while the animation runs the panel's `top` is measured from the
        wrapper -- which sits in normal flow directly below the button. HeadlessUI strips
        the classes when the transition ends, the transform goes with them, and the panel
        silently re-anchors to the nearest remaining positioned ancestor: the `relative`
        Popover, which wraps only the button.

        So the menu opened in the right place and then jumped 47px upwards, ending up on
        top of the button that opened it. Measured on production: panel top 77.8 during
        the transition, 30.5 once it settled, against a button spanning 16.5 to 64.5.

        Handing the classes to Popover.Panel itself removes the intermediate element, so
        the panel is positioned against the same `relative` Popover throughout -- and a
        transform on the panel cannot change what the panel itself is anchored to. This
        is what DesktopMenuPopover has always done.

        That makes the Popover the reference box in both phases, and the Popover is the
        button, so the 14px gap has to clear it: `calc(100% + 14px)`. It resolves to the
        same 78px the menu already opened at, which is where it visibly belongs.

        origin-top-right keeps the growing-out-of-the-button look the wrapper used to
        give for free -- it was a zero-height box directly under the button, so that is
        where the scale appeared to start. Scaling the panel about its own centre instead
        would read as the menu inflating in place.
      */}
      <Transition
        as={Fragment}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Popover.Panel className="absolute origin-top-right bg-white shadow-md p-4 rounded-md border-[1.5px] border-slate-200 grid grid-cols-2 gap-4 top-[calc(100%+14px)] w-[250px] right-0">
          <HelpLink href={buildUrl('/contact')} icon={faPhone} title="Contact Us" className="mb-0" />
          <HelpLink href={buildUrl('/help')} icon={faCommentQuestion} title="Help" className="mb-0" />
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}
